import { z } from 'zod'
import { ApiLocale } from '@library/enums'
import { enumWithEmpty } from './enum-with-empty'

/** 企業帳號 - 共用欄位 Schema */
export const corporateAccountCommonSchema = z.object({
  /** 習慣語言 */
  lang: enumWithEmpty(ApiLocale),
  /** 職稱 */
  title: z.string(),
  /** 聯絡人名 */
  firstName: z.string(),
  /** 聯絡人姓 */
  lastName: z.string(),
  /** 聯絡人姓名 */
  name: z.string(),
  /** 電話國碼 */
  countryCode: z.string(),
  /** 電話 */
  phoneNo: z.string(),
  /** E-mail */
  email: z.string()
})

/** 企業帳號 - 共用欄位 */
export interface CorporateAccountCommon
  extends z.infer<typeof corporateAccountCommonSchema> {}
